module.exports = __webpack_public_path__ + "static/firefly-logo-4cb4994027bfb231917fe168c1e69aa4.jpeg";